import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { FaEnvelope, FaPhone } from "react-icons/fa6";
import "./AppNavbar.css";

const AppNavbar = () => {
  return (
    <Navbar expand="lg" variant="dark" sticky="top" className="navbar-background">
      <Container className="align-items-center">
        <Navbar.Brand href="/" className="d-flex align-items-center">
          <img src="/assets/logo.png" alt="Logo" height="60" className="me-2" />
          <span className="d-xs-none d-sm-none d-md-block mobilehide">
            JP Enterprice
          </span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar-nav" />
        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
            <Nav.Link href="/services">Our Service</Nav.Link>
            <Nav.Link href="/contact">Contact Us</Nav.Link>
            <Nav.Link href="tel:8700115110"><FaPhone className="me-1" />+91 8700115110</Nav.Link>
            <Nav.Link href="mailto:prakashmeena678@gmail.com"><FaEnvelope className="me-1" />prakashmeena678@gmail.com</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
